/**
 * @Author: AI Assistant
 * @Date: 2025-07-02 15:42:00
 * @Description: 数据字典路由配置
 */

const MenuLayout = () => import('@/components/layout/index.vue')
const DictIndex = () => import('@/views/dict/index.vue')

export default [
  {
    path: 'dict',
    component: MenuLayout,
    children: [
      {
        path: '',
        component: DictIndex,
        name: 'Dict',
        meta: {
          name: '数据字典',
          context: 'manager',
          type: 'INNER_APP'
        }
      }
    ]
  }
]
